


import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class AppPopup extends Vue {

  @Prop({default: false})
  public opened!: boolean;

  @Emit('close')
  public emitClose(): void {
  }

  @Watch('opened', {immediate: false})
  public openedChange(): void {
    this.clearCloseAnimationTimeout();
    if (!this.opened) {
      this.cssClass = 'hidden';
      this.closeAnimationTimerHandler = setTimeout(() => {
        this.cssClass = '';
        this.isVisible = false;
      }, 800);
    } else {
      this.cssClass = '';
      this.isVisible = true;
    }
  }

  public isVisible: boolean = false;
  public cssClass: string = '';
  private closeAnimationTimerHandler: number | null = null;

  public close(): void {
    this.emitClose();
  }

  private clearCloseAnimationTimeout(): void {
    if (this.closeAnimationTimerHandler) {
      clearTimeout(this.closeAnimationTimerHandler);
    }
  }
}
